import { render, staticRenderFns } from "./addEditRedDialog.vue?vue&type=template&id=7d42f40c&scoped=true"
import script from "./addEditRedDialog.vue?vue&type=script&lang=js"
export * from "./addEditRedDialog.vue?vue&type=script&lang=js"
import style0 from "./addEditRedDialog.vue?vue&type=style&index=0&id=7d42f40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d42f40c",
  null
  
)

export default component.exports